const report = `${process.env.VUE_APP_URL}/api/v1/report`;
import { validateResponseError } from "@/store/utils.js";
import { title } from "process";
import { v4 as uuidv4 } from 'uuid'

export default {
  namespaced: true,
  state: {
    testImage: null,
    charts: [],
    reports: [],
    logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAAYCAMAAAABINXqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADbUExURUdwTCMhIRsaGRsbGxwcGxsbGhwaGhsbGUQqMRsaGRwbGhsaGRwbGRsaGhwaGRwbGiYlIx8bG01NTRwbGiooJx4cGxsaGR0cGi4uLhwbGhsbGk5OTRwcGxsaGRwbGjg4NR0cGzw8O0lJSBwbGjs7OkREQz8/PFhOUB0cGtYIR1FRUTw8Oi4tLVFRUL4YSoGAgDs7O2NjYlA9QpEuStEQTXh4eN4MS318fMkMRtMUThsaGTs7OldXVuQARW1sbFBQT2BgX3l5eUdHRi4uLT09PHtGVqMrT7oUR6dOaF0nfhIAAABFdFJOUwAd111SqGKrB7eS92ayo+++Jkn8EFjiPU5xisGYy0wYMvBqetsshdVG/Dqw9Oyhsb/23E5WxyrI1N7//////////////dnAiPIAAALiSURBVEjHxZbZdtowEIYFGLyAWWJsBweHfUtOs5zTNK2M7QRI0vd/oo4WyxJbEy7Cf4OFRtInzWhGCFEVLiRN0BlkDJayemdAuI1WMsLsm5bthWGocTdEUZTKDBc7xr7GVTg6aV/TrkWjLQa1aM9827qAMa6xzzEgbGSEH1t+shycqXIUwcK4kX0H+aAOQmWMi4cRLiOCoLhiqph2MP46QkUa9F+EAUGIBleZZrPZ1XA4NIRp8RSE8AsIU0oQDcWxL95ek+Tx5UqYVjE21dCYl0ol12/zAX0XmiWNIVRd1y1BTwPjMN8FQfBIjyEG9AWCsaEEY2F8F38kycvLMs3ygwGWdZkg83KDHsncYy2PIVC1KLeNFAQqgLuu0q+uQLhlh3CT2f6K4/gNANLV4ACCKw7YgaXaDbyLUDiCUOAbEAgTRvAgbH8DwmKZrlabzDfbCDqs3TRN4uwR7Al+iiaozhAc07Tt3j6EKukxUAvTT7OWIYwpwaadmf6Mid4BYL1e70cIeWh4ZCf0uvT2hOMuAg/HlghqjsCvgxQJRB9wMdM0NfYiFPnkHv2buCXIIvMwgq4glGSEIXNEnggWMQ0GiMflAUeoCD0WC55FKLqnIGSeMGRPvCdwK5NH9BkE5PMbEZ6McMOO4VYY/4kXQJC8JjefQwCITpdkr/mpCOiBMUzyW/n3legJSQjlYwgkWbHZ1FgwD4YjQ0BwPS1a0Hhuusx09/z8dH9/n78aYK2qXmbyETLB87VKpQMTBFACK0QBzOsiNCIXFZotCioGQfUEA6cDPQUZgdgEeYZeSzkdN5V8XFdrxChvXUstkqf83MpSa4QmRkgIpJRV8zolEzhttZx4CoIhypaOJIQRYvHIrdpFBQHZexBQ1+EIl9uHYG0/7GqWzuWTZoU0ywF98Wi2bet6PfCZ6Twowx+5FRV9xmi0B4oTn4W9cTqWeLPIBI0zvB0nkSMjuOd4Qk+bkrrfu/Y/57bcJIRKUzkAAAAASUVORK5CYII=",
    
    treeMap: null,
    whaleCurve: null,
    
    chart: { // This will hold the chart data for PDF generation with only one chart
      title: null,
      image: null
    },
    profitabilityTable: {
      title: null,
      description: null,
      columnDefs: [],
      rowData: []
    },
    validationReport: {
      title: null,
      description: null,
      columnDefs: [],
      rowData: []
    }
  },
  getters: {
  },
  mutations: {
    ADD_REPORT_TO_LIST(state, {title, description, type, orientation = 'portrait'}) {
      var generated_id = uuidv4();
      state.reports.push({ data: {...state[type]}, id: generated_id, title: title, description: description, orientation: orientation, visible: true});
    },
    REMOVE_REPORT(state, id) {
      state.reports = state.reports.filter(report => report.id !== id);
    },
    SET_VALIDATION_REPORT_TITLE(state, title){
      state.validationReport = { ...state.validationReport, title: title };
    },
    SET_VALIDATION_REPORT_DESCRIPTION(state, description){
      state.validationReport = { ...state.validationReport, description: description };
    },
    SET_VALIDATION_REPORT(state, rowData) {
      state.validationReport = rowData;
    },
    SET_PROFITABILITY_TABLE_TITLE(state, title) {
      state.profitabilityTable = { ...state.profitabilityTable, title: title };
    },
    SET_PROFITABILITY_TABLE_DESCRIPTION(state, description) {
      state.profitabilityTable = { ...state.profitabilityTable, description: description };
    },
    SET_PROFITABILITY_TABLE_DATA(state, { tableData }) {
      state.profitabilityTable = tableData;
    },
    SET_SINGLE_CHART_FOR_PDF(state, data){
      state.chart.title = data.title;
      state.chart.description = data.description;
      state.chart.image = data.image;
    },
    SET_IMAGE(state, data) {
      state.testImage = data
    },
    SET_CHARTS(state, chart) {
      var generated_id = uuidv4();
      state.charts.push({...chart, id:generated_id, visible: true});
    },
    REMOVE_CHART(state, id) {
      state.charts = state.charts.filter(chart => chart.id !== id);
    },
    SET_CHART_REFERENCE(state, {name, reference}) {
      state[name] = reference;
    },
    CLEAN_DATA(state) {
      state.testImage = null;
      state.charts = [];
      state.treeMap = null;
    }
  },
  actions: {
    getReportLine({ commit }, { context, id }) {
      return context.$http.get(`${report}/lines/${id}/`)
        .then(res => {
          commit("SET_LINE_FORM", res.data);
        });
    }
  }
}
